/**
 * This becomes bundle.js and acts as the central initiator
 */

const configurePublicPath = () => {
  // Use inline environment detection to avoid importing env-utils
  const isDev = process.env.NODE_ENV === 'development';

  // Defer heavy config logic to main application chunk
  // Only set public path if we have the global settings available
  if (!isDev && window.SkyFoundationSettings?.staticDomain) {
    /* eslint-disable-next-line no-undef, camelcase */
    __webpack_public_path__ = `${window.SkyFoundationSettings.staticDomain}sky-aem-frontend/clientlibs/dp_base/${process.env.VERSION}/`;
    /* eslint-disable-next-line no-undef, camelcase */
    __webpack_require__.p = __webpack_public_path__;
  }
};

/**
 * Load and start the main application
 * Use string-based dynamic import to ensure maximum separation
 */
const startApplication = async () => {
  try {
    configurePublicPath();

    // Use string-based dynamic import to minimize bundle inclusion
    const startClientModule = await import(/* webpackChunkName: "start-client" */ './start-client');

    // Call the exported function
    if (startClientModule.startClient) {
      startClientModule.startClient();
    } else if (startClientModule.default) {
      startClientModule.default();
    }
  } catch (error) {
    // Use native console.error (will be stripped in production)
    console.error('Bootstrap error:', error);
  }
};

// Start immediately
startApplication();
